<template>
  <el-form ref="form" :model="form" class="box-set" label-width="120px">
    <!-- <el-card header="绑定店铺" shadow="naver" v-if="!is_distributor">
      <div :span="23">
        <el-button type="primary" @click="relStoresClick">选择店铺</el-button>
        <el-table v-if="relStores.length > 0" :data="relStores" style="line-height: normal">
          <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
          <el-table-column label="名称" prop="name"></el-table-column>
          <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <i class="iconfont icon-trash-alt" @click="deleteStoreRow(scope.$index, form.items)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card> -->
    <el-card header="基础信息" shadow="naver">
      <el-form-item label="活动封面">
        <div class="frm-tips">
          只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）
        </div>
        <div>
          <imgBox
            :imgUrl="wximageurl + form.ad_pic"
            inline
            @click="handleImgChange"
          ></imgBox>
        </div>
        <imgPicker
          :dialog-visible="imgDialog"
          :sc-status="isGetImage"
          @chooseImg="pickImg"
          @closeImgDialog="closeImgDialog"
        ></imgPicker>
      </el-form-item>
      <el-form-item
        label="活动名称"
        prop="activity_name"
        :rules="{ required: true, message: '活动名称必填', trigger: 'blur' }"
      >
        <el-col :span="20">
          <el-input
            v-model="form.activity_name"
            :maxlength="30"
            placeholder="活动名称"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="活动时间">
        <el-col :span="20">
          <el-date-picker
            v-model="activity_date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="生效时间"
            end-placeholder="过期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="活动描述">
        <el-col :span="20">
          <el-input
            type="textarea"
            :rows="2"
            v-model="form.description"
            placeholder=""
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item
        label="每人累计限额"
        prop="limit_total_money"
        :rules="rules.limit_total_money"
      >
        <el-col :span="20">
          <el-input
            v-model="form.limit_total_money"
            :maxlength="30"
            placeholder="每人累计限额"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item
        label="单笔最少限额"
        prop="limit_money"
        :rules="rules.limit_money"
      >
        <el-col :span="20">
          <el-input
            v-model="form.limit_money"
            :maxlength="30"
            placeholder="每人单笔最少购买金额"
          ></el-input>
        </el-col>
      </el-form-item>
      <!--el-form-item label="是否包邮">
          <el-col :span="20">
            <el-radio v-model="form.is_free_shipping" label="true">包邮</el-radio>
            <el-radio v-model="form.is_free_shipping" label="false">商品自身运费模板</el-radio>
          </el-col>
        </el-form-item-->
      <!--el-form-item label="订单取消" prop="validity_period">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-input v-model="form.validity_period" placeholder="15" width="10">
                <template type="text" slot="prepend">下单</template>
              </el-input>
            </el-col>
            <div class="sub-title">分钟后未支付的订单，将自动取消</div>
          </el-row>
        </el-form-item-->
    </el-card>
    <el-card header="绑定商品" shadow="naver">
      <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
    </el-card>
    <el-card header="设置商品" shadow="naver">
      <el-table
        v-if="form.items.length > 0"
        :data="form.items"
        style="line-height: normal"
      >
        <el-table-column label="ID" prop="item_id" width="120"></el-table-column>
        <el-table-column
          label="商品编号"
          prop="item_bn"
          width="80"
        ></el-table-column>
        <el-table-column label="名称" prop="item_title"></el-table-column>
        <el-table-column label="类型" prop="special_type">
          <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.special_type == 'drug'"
              >处方药</span
            >
            <span style="color: blue" v-else>非处方药</span>
          </template>
        </el-table-column>
        <el-table-column label="活动价" width="100">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.activity_price"
              width="100"
              min="0.01"
              onkeyup="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="每人限购" width="80">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.limit_num"
              size="mini"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="库存" width="90">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.activity_store"
              width="90"
              size="mini"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sort"
              size="mini"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <i
              class="iconfont icon-trash-alt"
              @click="deleteItemRow(scope.$index, form.items)"
            ></i>
            <el-button v-if="scope.row.status == 'in_sale'" type="danger" size="mini" @click="removeItemNow(scope.row, scope.$index, form.items)">剔除商品</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 指定门店 start -->
    <el-card header="店铺" shadow="naver">
      <el-form-item label="适用店铺">
        <el-radio-group v-model="form.use_all_shops" @change="shopTypeChange">
          <el-radio label="true">全部适用</el-radio>
          <el-radio label="false">指定店铺适用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="以下店铺不可用">
        <el-checkbox-group
          v-model="form.distributor_id_noflag"
          @change="choseDistributorNo"
        >
          <el-checkbox label="true">怡康自营选中店铺不可用</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="清空选中店铺">
        <el-button @click="clearChoseDistributor()">清空选中店铺</el-button>
      </el-form-item>
      <div v-if="!zdShopHidden">
        <el-button type="primary" @click="addDistributorAction"
          >选择店铺</el-button
        >
        <el-table
          v-if="distributor_info.length > 0"
          :data="distributor_info"
          style="line-height: normal"
        >
          <el-table-column
            label="ID"
            prop="distributor_id"
            width="60"
          ></el-table-column>
          <el-table-column label="名称" prop="name"></el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <i
                class="iconfont icon-trash-alt"
                @click="deleteDistritutorRow(scope.$index, form.items)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 指定门店 end -->
    <!-- <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-data-ids="relStores" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect> -->
    <div class="content-center">
      <el-button @click.native="handleCancel">返回</el-button>
      <el-button
        type="primary"
        @click="submitActivityAction()"
        v-if="this.copy_flag"
        >复制活动</el-button
      >
      <el-button
        v-else-if="form.status !== 'it_has_ended'"
        type="primary"
        @click="submitActivityAction()"
        >保存</el-button
      >
    </div>
    <!-- 指定门店 start -->
    <StoreSelect
      :store-visible="storeVisible"
      :is-valid="true"
      :rel-shop-ids="relShopIds"
      :get-status="setStatus"
      @chooseStore="chooseStoreAction"
      @closeStoreDialog="closeStoreDialogAction"
    ></StoreSelect>
    <DistributorSelect
      :store-visible="distributorVisible"
      :is-valid="true"
      :rel-data-ids="distributor_info"
      :get-status="setDistributorStatus"
      @chooseStore="chooseDistributorAction"
      @closeStoreDialog="closeDistributorDialogAction"
    ></DistributorSelect>
    <!-- 指定门店 end -->
  </el-form>
</template>

<script>
import {
  seckillActivityCreate,
  seckillActivityGetInfo,
  seckillActivityUpdate,
  removeItem,
} from "../../../../api/promotions";
import { getDefaultCurrency } from "../../../../api/company";
import SkuSelector from "@/components/function/skuSelector";
// import StoreSelect from '@/components/function/distributorSelect'
import imgPicker from "@/components/imageselect";
import imgBox from "@/components/element/imgBox";
import store from "@/store";
// 指定门店 -- start --
import StoreSelect from "@/components/storeselect";
import DistributorSelect from "@/components/storeListSelect";
// 指定门店 -- end -
export default {
  inject: ["refresh"],
  components: {
    StoreSelect,
    SkuSelector,
    imgPicker,
    imgBox,
    DistributorSelect,
  },
  data() {
    return {
      is_distributor: false,
      cursymbol: "￥",
      goodsVisible: false,
      community: "1",
      communityList: [],
      communitycount: 0,
      relItems: [],
      addedItems: [],
      // 指定门店 -- start --
      distributorVisible: false, // 分销商可见，默认false
      setDistributorStatus: false,
      rel_shops_ids: [], // 指定适用门店ID集合
      distributor_info: [], // 指定适用门店信息集合
      relShopIds: "",
      relDistributorIds: "",
      zdShopHidden: true,
      setStatus: false,
      storeVisible: false,
      // 指定门店 -- end --
      communityParams: {
        page: 1,
        pageSize: 10,
        status: "open",
      },
      copy_flag: false,
      form: {
        seckill_id: "",
        activity_name: "",
        description: "",
        activity_start_time: "",
        activity_end_time: "",
        activity_release_time: "",
        validity_period: 15,
        is_free_shipping: "false",
        is_activity_rebate: "false",
        distributor_id: [],
        // 指定门店 -- start --
        use_all_shops: "true", // 默认全部门店适用
        rel_shops_ids: [], // 指定适用门店ID集合
        // 指定门店 -- end --
        items: [],
        ad_pic: "",
        seckill_type: "limited_time_sale",
        item_type: "normal",
        limit_total_money: "",
        limit_money: "",
        distributor_id_noflag: "false",
      },
      activity_date: "",
      relItemsIds: [],
      selectItemType: "normal",
      itemVisible: false,
      setItemStatus: false,
      imgDialog: false,
      isGetImage: false,
      storeVisible: false,
      setStatus: false,
      relStores: [],
      rules: {
        limit_total_money: [
          {
            pattern: /^[0-9]+(.[0-9]{1,2})?$/,
            message: "请输入一个正确格式的金额",
          },
        ],
        limit_money: [
          {
            pattern: /^[0-9]+(.[0-9]{1,2})?$/,
            message: "请输入一个正确格式的金额",
          },
        ],
      },
    };
  },
  methods: {
    closeStoreDialogAction() {
      this.storeVisible = false;
    },
    chooseStoreAction(data) {
      this.storeVisible = false;
      this.form.shop_ids = [];
      if (data === null || data.length <= 0) return;
      this.relStores = data;
    },
    deleteStoreRow(index) {
      this.setStatus = false;
      this.relStores.splice(index, 1);
    },
    relStoresClick() {
      this.storeVisible = true;
      this.setStatus = true;
    },
    choseDistributorNo(val) {
      if (val === "true") {
        this.from.distributor_id_noflag = true;
      }
    },
    clearChoseDistributor() {
      this.relDistributorIds = "";
      this.distributor_info = [];
      this.form.distributor_id = [];
    },
    getItems(data) {
      let arr = [];
      data.forEach((item, index) => {
        let newData = "";
        let isInArr = this.addedItems.findIndex(
          (n) => n.item_id == item.itemId
        );
        if (isInArr == -1) {
          newData = {
            item_id: item.itemId,
            item_bn: item.itemBn,
            item_title: item.itemName,
            special_type: item.special_type,
            // 默认设置活动库存 9999
            activity_store: 9999, //item.store,
            activity_price: item.price / 100,
            special_type: item.special_type,
            item_spec_desc: item.item_spec_desc,
            sort: item.sort,
            limit_num: 0,
            item_type: item.item_type,
          };
        } else {
          newData = this.addedItems[index];
        }
        arr.push(newData);
      });
      this.form.items = arr;
    },
    handleImgChange() {
      this.imgDialog = true;
      this.isGetImage = true;
    },
    pickImg(data) {
      this.form.ad_pic = data.url;
      this.imgDialog = false;
    },
    closeImgDialog() {
      this.imgDialog = false;
    },
    communityChange(val) {
      if (val == 1) {
        this.form.community = [];
      }
    },
    deleteItemRow: function (index, rows) {
      rows.splice(index, 1);
      this.form.items = rows;
      this.setItemStatus = false;
      this.relItemsIds.splice(index, 1);
    },
    submitActivityAction() {
      const that = this;
      if (this.form.limit_total_money) {
        this.form.limit_total_money = this.form.limit_total_money;
      }
      if (this.form.limit_money) {
        this.form.limit_money = this.form.limit_money;
      }

      if (this.activity_date.length > 0) {
        this.form.activity_release_time = this.form.activity_start_time =
          this.activity_date[0];
        this.form.activity_end_time = this.activity_date[1];
      }
      // 表单提交数据过大
      if (this.form.distributor_info) {
        this.form.distributor_info = []
      }
      // if (this.relStores) {
      //   this.form.distributor_id = []
      //   this.relStores.forEach(item => {
      //     this.form.distributor_id.push(item.distributor_id)
      //   })
      // }
      let params = JSON.stringify(this.form);
      params = JSON.parse(params);
      params.items = JSON.stringify(params.items);
      if (this.form.seckill_id) {
        seckillActivityUpdate(params).then((res) => {
          if (res.data.data.seckill_id) {
            this.loading = false;
            this.$message({
              message: "更新成功",
              type: "success",
              duration: 2 * 1000,
              onClose() {
                that.refresh();
                that.$router.go(-1);
              },
            });
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      } else {
        seckillActivityCreate(params).then((res) => {
          if (res.data.data.seckill_id) {
            this.loading = false;
            this.$message({
              message: "添加成功",
              type: "success",
              duration: 2 * 1000,
              onClose() {
                that.refresh();
                that.$router.go(-1);
              },
            });
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
    // 指定门店 -- start --
    shopTypeChange(val) {
      this.zdShopHidden = true;
      if (val === "false") {
        this.zdShopHidden = false;
      } else {
        this.form.distributor_id = [];
      }
    },
    addDistributorAction() {
      this.distributorVisible = true;
      this.setDistributorStatus = true;
    },
    chooseStoreAction(data) {
      this.storeVisible = false;
      this.form.rel_shops_ids = [];
      if (data === null || data.length <= 0) return;
      this.rel_shops_ids = data;
      for (var i = 0; i < data.length; i++) {
        if (this.form.rel_shops_ids.indexOf(data[i].wxShopId) < 0) {
          this.form.rel_shops_ids.push(Number(data[i].wxShopId));
        }
      }
    },
    chooseDistributorAction(data) {
      this.distributorVisible = false;
      if (data === null || data.length <= 0) return;
      this.distributor_info = data;
      this.form.distributor_id = []; // 重新初始化，避免重选时旧店铺 ID 残留
      for (var i = 0; i < data.length; i++) {
        if (
          this.form.distributor_id.indexOf(Number(data[i].distributor_id)) < 0
        ) {
          this.form.distributor_id.push(Number(data[i].distributor_id));
        }
      }
    },
    closeStoreDialogAction() {
      this.storeVisible = false;
    },
    closeDistributorDialogAction() {
      this.distributorVisible = false;
    },
    deleteDistritutorRow(index) {
      this.distributor_info.splice(index, 1);
      let shopDatas = this.distributor_info;
      this.form.distributor_id = []; // 重新初始化 distributor_id 为空数组
      for (var i = 0; i < shopDatas.length; i++) {
        if (
          this.form.distributor_id.indexOf(
            Number(shopDatas[i].distributor_id)
          ) < 0
        ) {
          this.form.distributor_id.push(Number(shopDatas[i].distributor_id));
        }
      }
    },
    // 指定门店 -- end --
    getTaskTime(strDate) {
      let date = new Date(strDate);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let str = y + "-" + m + "-" + d;
      return str;
    },
    getActivityDetail(id) {
      seckillActivityGetInfo({ seckill_id: id }).then((res) => {
        let response = res.data.data;
        let distributor_id = [];
        this.distributor_info = response.distributor_info;
        for (var i in this.distributor_info) {
          if (
            distributor_id.indexOf(
              Number(this.distributor_info[i].distributor_id)
            ) < 0
          ) {
            distributor_id.push(
              Number(this.distributor_info[i].distributor_id)
            );
          }
        }
        console.log(distributor_id);
        let data = {
          // 复制活动提交去掉秒杀id
          seckill_id: this.copy_flag ? "" : response.seckill_id,
          activity_name: response.activity_name,
          limit_money: response.limit_money / 100,
          limit_total_money: response.limit_total_money / 100,
          description: response.description,
          activity_start_time: response.activity_start_time,
          activity_end_time: response.activity_end_time,
          validity_period: response.validity_period,
          is_free_shipping: response.is_free_shipping,
          is_activity_rebate: response.is_activity_rebate,
          seckill_type: response.seckill_type,
          // distributor_id: response.distributor_id,
          status: response.status,
          items: "",
          ad_pic: response.ad_pic,
          item_type: response.item_type,
          use_all_shops: response.use_all_shops,
          distributor_info: response.distributor_info,
          distributor_id: distributor_id,
        };
        // if (response.distributor_info) {
        //   this.relStores = response.distributor_info
        // }
        Object.assign(this.form, data);
        if (this.form.use_all_shops === "false") {
          this.zdShopHidden = false;
        }
        this.addedItems = response.items;
        this.activity_date = [
          response.activity_start_date,
          response.activity_end_date,
        ];
        this.relItems = response.itemTreeLists || [];
      });
    },
    handleCancel: function () {
      this.$router.go(-1);
    },
    // 剔除正在执行策略的商品
    removeItemNow(row, index, rows) {
      if (rows.length <= 1) {
        this.$message({
          type: 'error',
          message: '当前活动仅剩一个商品，不能剔除，请直接关闭活动。'
        })
        return false;
      }
      let query = {
        'seckill_id': row.seckill_id,
        'item_id': row.item_id
      }
      console.log(row)
      let ms = '确定要将当前商品（'+ row.item_bn +'）从活动中剔除？'
      this.$confirm(ms, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeItem(query).then(response => {
          this.$message({
            message: '剔除成功，请在客户端进行检查',
            type: 'success',
            duration: 5 * 1000
          })
          rows.splice(index, 1);
          this.form.items = rows;
          this.setItemStatus = false;
          this.relItemsIds.splice(index, 1);
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '剔除失败'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  },
  mounted() {
    if (store.getters.login_type === "distributor") {
      this.is_distributor = true;
    }
    if (this.$route.params.seckill_id) {
      this.getActivityDetail(this.$route.params.seckill_id);
    }

    if (this.$route.query.copy_seckill_id) {
      this.getActivityDetail(this.$route.query.copy_seckill_id);
      this.copy_flag = true;
    }
  },
};
</script>



// WEBPACK FOOTER //
// add.vue?662a9542